import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { RightsContext } from 'providers/RightsContext';

export const OfferFeeCatalogCardSummary = ({ t, negotiationStatus, numberOfFees }) => {
  const { offerIncomeSchemaWrite } = useContext(RightsContext);
  
  return (
    <Grid item xs={12}>
      {numberOfFees === 0 && offerIncomeSchemaWrite ? (
        t('ResultsNotFound')
      ) : (
        <Grid container spacing={1}>
          {negotiationStatus && (
            <Grid item xs={12} sm={6} md={6}>
              <span id={'IncomeFeeCardHeader_summary_label'}>{t('OfferEdit.FeeCatalog.NegotiationStatus')} : </span>
              <span id={'IncomeFeeCardHeader_summary_value'}>{t(`OfferEdit.FeeCatalog.${negotiationStatus}`)}</span>
            </Grid>
          )}
        </Grid>
      )}
    </Grid>
  );
};

OfferFeeCatalogCardSummary.propTypes = {
  t: PropTypes.func.isRequired,
  negotiationStatus: PropTypes.string,
  numberOfFees: PropTypes.number
};

export default compose(withTranslation()(OfferFeeCatalogCardSummary));
